export const CustomErrorCode = {
  USER_EMAIL_EXISTS: "USER_EMAIL_EXISTS",
  COURSE_HAS_NO_LESSONS: "COURSE_HAS_NO_LESSONS",
  USER_STUDENT_PROGRESS_EXISTS: "USER_STUDENT_PROGRESS_EXISTS",
  USER_STUDENT_FLASHCARDS_EXISTS: "USER_STUDENT_FLASHCARDS_EXISTS",
  USER_BANNED: "USER_BANNED",
} as const;

export type CustomErrorCodeType = (typeof CustomErrorCode)[keyof typeof CustomErrorCode];
